import { getConfig } from '../Config/ApplicationConfig';
import { getExecutor } from '../Shared/HttpRequestExecutor';
export function getUsers(query, activeOnly, limit) {
    if (query === void 0) { query = ''; }
    if (activeOnly === void 0) { activeOnly = false; }
    if (limit === void 0) { limit = 50; }
    return getExecutor(getConfig().apiEndpoints.authorisation).get("api/v1/users/search?query=" + query + "&activeOnly=" + activeOnly + "&limit=" + limit);
}
export function getUserPermissions(id) {
    return getExecutor(getConfig().apiEndpoints.authorisation).get("api/v1/users/" + id + "/permissions");
}
export function updateUserPermissions(id, permissions) {
    return getExecutor(getConfig().apiEndpoints.authorisation).put("api/v1/users/" + id + "/permissions/all", permissions);
}
export function getCurrentPermissions() {
    return getExecutor(getConfig().apiEndpoints.authorisation).get("api/v1/users/me/permissions");
}
export function getCurrentUser() {
    return getExecutor(getConfig().apiEndpoints.authorisation).get("api/v1/users/me");
}
export function getSystemContact() {
    return getExecutor(getConfig().apiEndpoints.authorisation).get("api/v1/users/system-contact/");
}
export function getUserById(id) {
    return getExecutor(getConfig().apiEndpoints.authorisation).get("api/v1/users/" + id);
}
export function createUser(queryObject) {
    return getExecutor(getConfig().apiEndpoints.authorisation).post("api/v1/users/", queryObject);
}
export function updateUser(id, queryObject) {
    return getExecutor(getConfig().apiEndpoints.authorisation).put("api/v1/users/" + id, queryObject);
}
export function getUsersParentGroups(id) {
    return getExecutor(getConfig().apiEndpoints.authorisation).get("api/v1/users/" + id + "/groups/parents");
}
export function updateUsersParentGroups(id, data) {
    return getExecutor(getConfig().apiEndpoints.authorisation).put("api/v1/users/" + id + "/groups/parents", data);
}
export function getGroups(query, activeOnly, limit) {
    if (query === void 0) { query = ''; }
    if (activeOnly === void 0) { activeOnly = false; }
    if (limit === void 0) { limit = 50; }
    return getExecutor(getConfig().apiEndpoints.authorisation).get("api/v1/groups/search?query=" + query + "&activeOnly=" + activeOnly + "&limit=" + limit);
}
export function getGroupById(id) {
    return getExecutor(getConfig().apiEndpoints.authorisation).get("api/v1/groups/" + id);
}
export function getGroupPermissions(id) {
    return getExecutor(getConfig().apiEndpoints.authorisation).get("api/v1/groups/" + id + "/permissions");
}
export function getDefaultGroup() {
    return getExecutor(getConfig().apiEndpoints.authorisation).get("api/v1/groups/default");
}
export function getGroupsParentGroups(id) {
    return getExecutor(getConfig().apiEndpoints.authorisation).get("api/v1/groups/" + id + "/parents");
}
export function getGroupsGroupMembers(id) {
    return getExecutor(getConfig().apiEndpoints.authorisation).get("api/v1/groups/" + id + "/members");
}
export function createGroup(queryObject) {
    return getExecutor(getConfig().apiEndpoints.authorisation).post("api/v1/groups/", queryObject);
}
export function updateGroup(id, queryObject) {
    return getExecutor(getConfig().apiEndpoints.authorisation).put("api/v1/groups/" + id, queryObject);
}
export function deleteGroup(groupId) {
    return getExecutor(getConfig().apiEndpoints.authorisation).delete("api/v1/groups/" + groupId);
}
export function updateGroupMembers(id, queryObject) {
    return getExecutor(getConfig().apiEndpoints.authorisation).put("api/v1/groups/" + id + "/members", queryObject);
}
export function updateGroupParentGroups(id, queryObject) {
    return getExecutor(getConfig().apiEndpoints.authorisation).put("api/v1/groups/" + id + "/parents", queryObject);
}
